<template>
  <v-card id="sidebar-consultation-quick-reference" class="rounded-lg" width="100%" elevation="0" v-bind="$attrs" :height="$attrs.height || '90vh'">
    <v-card-title style="display: block;">
      <h4 class="primary--text word-wrap">
        {{ patient.full_name || patient.first_name+' '+patient.last_name }}<br />
        <small style="color:black;">Gender: {{patient.gender}}</small>
        <br />
        <small style="color:black;">
                    
          <div v-if="consultation.started_at" class="mobile-number-wrapper">

            <div @click="openCallWindow(index)" id="consultation-call-via-app" v-show="(consultation.patient.firebase_tokens.length > 0 || consultation.patient.devices.length > 0) && !windowOpen">
              <v-icon style="color: #fff;">mdi-cellphone-wireless</v-icon>
              <span> Click here to call via Mobile App</span>
            </div>

            <hr v-show="consultation.patient.firebase_tokens.length > 0 || consultation.patient.devices.length > 0" />

            <h4>Mobile #:</h4>
            <span v-if="patient.patient_contact_numbers != null">
              <span v-show="JSON.parse(patient.patient_contact_numbers).length <= 1">
                <a v-show="patient.mobile_number != 'N/A'" :href="`tel:${parsedMobile(patient.mobile_number)}`" class="mobile-number-options">{{parsedMobile(patient.mobile_number)}}</a>
              </span>
              <a v-for="(item, key, index) in JSON.parse(patient.patient_contact_numbers)" :id="index" :key="key" :href="`tel:${parsedMobile(item.contact_number)}`" class="mobile-number-options" v-show="item.is_primary == 1">{{parsedMobile(item.contact_number)}}</a>
            </span>

            <span v-if="patient.patient_contact_numbers == null">
              <a v-show="patient.mobile_number != 'N/A'" :href="`tel:${parsedMobile(patient.mobile_number)}`" class="mobile-number-options">{{parsedMobile(patient.mobile_number)}}</a>
            </span>
          </div>

          <v-row>
            <v-col cols="12">
              <hr />
            </v-col>
          </v-row>

          <div v-if="consultation.started_at && consultation.status == 'ongoing'" class="mobile-number-lock">
            <div>
              <h3 class="primary--text"><strong>Time:</strong> <small style="color: #000;">{{ timerCount }}</small></h3>
            </div>
          </div>

          <div v-if="!consultation.started_at" class="mobile-number-lock">
            <button @click="updateStartDate(consultation.id)" class="blue-button">START CONSULTATION</button>
          </div>

        </small>
      </h4>
    </v-card-title>
    
    <v-card-text class="overflow-y" :style="{height : contentHeight}">
      <v-skeleton-loader v-if="!patient" type=" text, sentences, sentences, sentences, text, text, sentences, sentences, sentences"></v-skeleton-loader>
      <div v-else>
        <!-- keymaps -->
        <v-row dense>
          <!-- divider -->
          <v-col cols="12" class="my-3">
            <v-divider class="white"></v-divider>
          </v-col>

          <div style="width: 100%; text-align: center;" class="mb-4">
            <h3>Biometric Data</h3>
          </div>

          <!-- section2 -->
          <v-col v-for="key in keyMap.section2" :key="key.value" :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" cols='12'>
            <span class="d-block">{{ key.name }}</span>
            <span :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`">
              {{ patient[key.value] ? patient[key.value] : 'N⁄A' }}
            </span>
          </v-col>

          <!-- divider -->
          <v-col cols="12" class="my-3">
            <v-divider class="white"></v-divider>
          </v-col>

          <!-- section2 -->
          <v-col v-for="key in keyMap.section3" :key="key.value" :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" cols='12'>
            <span class="d-block">{{ key.name }}</span>
            <span :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`">
              {{ patient[key.value] ? patient[key.value] : 'N⁄A' }}
            </span>
          </v-col>

          <!-- divider -->
          <v-col cols="12" class="my-3">
            <v-divider class="white"></v-divider>
          </v-col>

          <div style="width: 100%; text-align: center;" class="mb-4">
            <h3>General Information</h3>
          </div>

          <!-- section1 -->
          <v-col
            v-for="key in keyMap.section1" :key="key.value" :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" cols='12'>
            
            <span class="d-block">{{ key.name }}</span>
            <span :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`">
              <span v-if="key.value == 'is_vip'">{{ patient[key.value] ? 'Yes' : 'No' }}</span>
              <span v-if="key.value == 'has_warning'">{{ patient[key.value] ? patient[key.value] : 'N/A'}}</span>
              
              <span v-if="key.section == 'case' && key.section != 'is_vip' && key.section != 'has_warning' && case_info">
                {{ case_info[key.value] ? case_info[key.value] : 'N⁄A' }}
              </span>
              <span v-if="key.section == 'patient' && key.value != 'is_vip' && key.value != 'has_warning'">
                {{ patient[key.value] ? patient[key.value] : 'N⁄A' }}
              </span>
              <span v-if="key.section == 'user' && key.value != 'is_vip' && key.value != 'has_warning'">
                {{ user[key.value] ? user[key.value] : 'N⁄A' }}
              </span>
            </span>
          </v-col>

          <!-- divider -->
          <!-- <v-col cols="12" class="my-3">
            <v-divider class="white"></v-divider>
          </v-col> -->

          <!-- section3 -->
          <!-- <v-col :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" cols='12'>
            <span class="d-block">Case ID</span>
            
            <span :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`">
              {{ case_info ? case_info.id : 'N⁄A' }}
            </span>
          </v-col>

          <v-col :class="{'d-flex':$vuetify.breakpoint.lgAndUp, 'pt-0': true}" cols='12'>
            <span class="d-block">Consult</span>
            <span :class="`ml-auto ${$vuetify.breakpoint.lgAndUp ? 'font-weight-bold':'font-weight-bold'}`">
              {{ case_info ? case_info.consultations.length + ' (for this case)' : 'N⁄A' }}
            </span>
          </v-col> -->

        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import moment from 'moment';
  import API from '@/api';

  const callRepo = API.get('Call')

  export default {
    name: 'AppPatientProfile',

    computed: {
      consultation() {
        return this.$store.getters['consultation/activeInfo']
      },
      patient() {
        return this.$store.getters['patient/patient'] || {};
      },
      user() {
        return this.$store.getters['patient/fullData']
      },
      patientName () {
        return this.$store.getters['patient/fullName'] || this.$store.getters['patient/patient'].full_name
      },
      case_info () {
        return this.$store.getters['cases/activeInfo']
      }
    },

    methods: {

      parsedMobile (mobile) {

        if (mobile == null) {
          return '';
        }

        let first3 = mobile.slice(0, 3);
        if (first3 == '+63') {
          return mobile.replace(first3, '0');
        }

        let first2 = mobile.slice(0, 2);
        if (first2 == '63') {
          return mobile.replace(first2, '0');
        }

        return mobile;
      },

      async updateStartDate(consultation_id) {
        let consultation_start = await this.$store.dispatch('consultation/updateStartDate', { id: consultation_id });
        this.$store.commit('consultation/setActiveConsultation', consultation_start);
        console.log("[consultation_start]", consultation_start);
      },

      /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

      async openCallWindow() {
        localStorage.removeItem('call_window_closed')
        localStorage.removeItem('call_channel')
        await this.saveInfo();
        var w = 1000, h = 700;
        var left = Number((screen.width/2)-(w/2))
        var top = Number((screen.height/2)-(h/2));
        
        var windowFeatures = `directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=${w},height=${h},top=${top},left=${left}`;
        let routeUrl = this.$router.resolve({
          path: "/call"
        });

        this.windowOpen = true;
        window.open(routeUrl.href, 'Call Window', windowFeatures);
      },

      async detectWindowClosed () {
        let status = localStorage.getItem('call_window_closed')
        let channelName = localStorage.getItem('call_channel')

        if (status == 'closed_ringing') {
          callRepo.endCall(channelName, true); 
          try {
            callRepo.recordCall(channelName, 'stop', this.consultation.patient.id);            
          } catch (error) {
            console.log('Error Stopping Recording: ', error)
          }
          this.windowOpen = false;
          localStorage.removeItem('call_window_closed')
          localStorage.removeItem('call_channel')
        } else if (status == 'connected_closed') {
          try {
            callRepo.recordCall(channelName, 'stop', this.consultation.patient.id);            
          } catch (error) {
            console.log('Error Stopping Recording: ', error)
          }
          this.windowOpen = false;
          localStorage.removeItem('call_window_closed')
          localStorage.removeItem('call_channel')
        } else if (status == 'hanged_up') {
          localStorage.removeItem('call_window_closed')
          localStorage.removeItem('call_channel')
          this.windowOpen = false;
        } else if (status == 'closed_rejected') {
          localStorage.removeItem('call_window_closed')
          localStorage.removeItem('call_channel')
          this.windowOpen = false;
        }
      },

      /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

      /**
       * Save consultation info to localStorage
       * Info will be used in audio/video call
       */
      async saveInfo() {
        localStorage.setItem('consultation', JSON.stringify(this.consultation));
      },

      /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */
    },

    watch: {
      consultation: async function (val) {
        console.log(val);
        this.consultation_start_date = val.started_at;
      },
    },

    props: {
      contentHeight: {
        type: String,
        default: '85%'
      }
    },

    data:()=>({
      timerCount: null,
      consultation_start_date: null,
      windowOpen: false,
      keyMap: {
        section1: [
          {name: 'Language', value: 'preferred_language', section: 'patient'},
          {name: 'Case No.', value: 'case_number', section: 'case'},
          // {name: 'PMS Case No.', value: 'pms_case_number', section: 'case'},
          {name: 'Caller First Name', value: 'caller_first_name', section: 'case'},
          {name: 'Caller Family Name', value: 'caller_family_name', section: 'case'},
          {name: 'Caller Role', value: 'caller_role', section: 'case'},
          {name: 'Provider name', value: 'provider_name', section: 'case'},
          {name: 'Company name', value: 'name_of_company', section: 'case'},
          {name: 'VIP', value: 'is_vip', section: 'patient'},
          {name: 'Warning', value: 'has_warning', section: 'patient'},
          {name: 'Warning reason', value: 'warning_reason', section: 'patient'},
        ],
        section2: [
          {name: 'Date measured', value: 'date_measured', section: 'patient'},
          {name: 'Height (cm)', value: 'height', section: 'patient'},
          {name: 'Weight (kg)', value: 'weight', section: 'patient'},
          {name: 'BMI', value: 'bmi', section: 'patient'},
        ],
        section3: [
          {name: 'Marital status', value: 'marital_status', section: 'patient'},
          {name: 'Age', value: 'age', section: 'patient'},
          {name: 'Birthdate', value: 'birthdate', section: 'patient'},
        ],
      }
    }),

    mounted() {
      this.consultation_start_date = this.consultation.started_at,
      setInterval(() => {
        if(this.consultation_start_date != null) {

          this.detectWindowClosed()

          let startTime = moment(this.consultation_start_date, 'YYYY-MM-DD hh:mm:ss');
          let current_time = moment();

          let duration = moment.duration(current_time.diff(startTime));
          var seconds = duration.asSeconds();

          //days 
          let days = Math.floor(seconds/(24*3600)); 
          seconds -= days*24*3600; 
           
          //hours 
          let hours = Math.floor(seconds/3600); 
          seconds -= hours*3600; 
           
          //minutes 
          let minutes = Math.floor(seconds/60); 
          seconds -= minutes*60; 

          let days_gap = days > 9 ? days : '0' + days;
          let hours_gap = hours > 9 ? hours : '0' + hours;
          let minutes_gap = minutes > 9 ? minutes : '0' + minutes;
          let seconds_gap = seconds > 9 ? seconds : '0' + seconds;

          if(days_gap > 0) {
            this.timerCount = days_gap+" days, "+hours_gap+":"+minutes_gap+":"+Math.round(seconds_gap);
          } else {
            this.timerCount = hours_gap+":"+minutes_gap+":"+Math.round(seconds_gap);
          }
        }
      }, 1000);

      console.log({ case_info: this.$store.getters['cases/activeInfo']});
      console.log({ test: this.$store.getters['patient/fullData']});
      console.log({ test2: this.$store.getters['patient/patient'] })
    }
  }
</script>

<style lang="scss" scoped>
  span { font-size: .9em; }
  .word-wrap { word-break: break-word; }
  .mobile-number-options { padding: 2px 5px; display: inline-block; word-break: normal; font-size: 13px; line-height: 13px; }  
  .blue-button {
    background-color: #258bf5;
    border-radius: 15px;
    padding: 5px 15px;
    color: #fff;
    font-size: 12px;
    width: 100%;
    right: 0;
    top: -45px;
    font-weight: bold;
    cursor: pointer;
  }

  #consultation-call-via-app {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    padding: 15px;
    background: #258bf5 !important;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
  }
</style>